import React from 'react';
import { Button, Modal } from 'rsuite';
import styled from 'styled-components';

const StyledModal = styled(Modal)`
  width: 380px;
  height: 344px;
  border-radius: 6px;
  box-shadow:
    0 2px 3px 0 rgba(8, 10, 37, 0.03),
    0 4px 8.5px 0 rgba(8, 10, 37, 0.05),
    0 7.5px 35px 0 rgba(89, 126, 247, 0.03);
  background-color: #ffffff;

  .rs-modal-dialog {
    height: 100%;
  }
  .rs-modal-content {
    height: 100%;
    display: flex;
    flex-direction: column;
  }
`;

const StyledModalBody = styled(Modal.Body)`
  flex-grow: 1;
`;

export function MapInfoModal(props) {
  const { closeModal, info } = props;
  return (
    <StyledModal open={true} onClose={closeModal}>
      <Modal.Header>
        <Modal.Title>{info.city}</Modal.Title>
      </Modal.Header>
      <StyledModalBody>Data Not Available</StyledModalBody>
      <Modal.Footer>
        <Button onClick={closeModal} appearance="primary">
          Hide
        </Button>
      </Modal.Footer>
    </StyledModal>
  );
}
